var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "facebook--path-1",
    points: "0 0.000216824618 16 0.000216824618 16 15.9997832 0 15.9997832"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-45.000000, -146.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.000000, 139.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "facebook--mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#facebook--path-1"
  })), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("path", {
    d: "M15.99968,8.0952 C15.94688,12.5128 12.32288,16.052 7.90528,15.9992 C3.48688,15.9464 -0.05152,12.3232 0.00048,7.9048 C0.05248,3.4872 3.67728,-0.052 8.09488,0.0008 C12.51328,0.0528 16.05168,3.6776 15.99968,8.0952",
    fill: "#3C5A97",
    mask: "url(#facebook--mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.59816,12.27216 L6.92296,12.25216 L6.97016,8.29296 L5.86296,8.27936 L5.88136,6.74736 L7.01416,6.76096 L7.03096,5.28016 C7.04056,4.47456 7.68296,3.73136 8.72056,3.74336 L10.18376,3.76096 L10.16616,5.22976 L9.17256,5.21856 C8.71976,5.21296 8.71016,5.26656 8.70536,5.64976 L8.68856,6.78096 L10.14776,6.79856 L9.96776,8.32816 L8.64616,8.31296 L8.59816,12.27216 Z",
    fill: "#FFFFFF"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.1fc00978ca231ae16bad1ac60e262245.svg";
export { ForwardRef as ReactComponent };